import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Compass, Users, User, Plus } from 'lucide-react';
import { cn } from '@/utils/cn';
import { useAuthStore } from '@/store/authStore';

const navItems = [
  { path: '/', label: 'Home', icon: Home, color: '#6366F1' },
  { path: '/explore', label: 'Explore', icon: Compass, color: '#F59E0B' },
  { path: '/groups', label: 'Groups', icon: Users, color: '#10B981' },
  { path: '/profile', label: 'Profile', icon: User, color: '#8B5CF6' },
];

export function BottomNav() {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  return (
    <>
      {/* Floating Action Button */}
      {isAuthenticated && (
        <Link
          to="/create"
          className="fixed bottom-24 right-4 z-50 md:hidden"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bottom-nav__fab"
          >
            <Plus className="w-7 h-7 text-white" />
          </motion.div>
        </Link>
      )}

      {/* Bottom Navigation Bar */}
      <nav className="bottom-nav">
        <div className="bottom-nav__items px-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || 
              (item.path !== '/' && location.pathname.startsWith(item.path));
            const Icon = item.icon;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  'bottom-nav__item',
                  isActive && 'bottom-nav__item--active'
                )}
              >
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  className="relative"
                >
                  <Icon
                    className={cn(
                      'w-6 h-6 transition-all duration-200',
                      isActive && 'scale-110'
                    )}
                    style={{ color: isActive ? item.color : '#94A3B8' }}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                  {isActive && (
                    <motion.div
                      layoutId="bottomNavIndicator"
                      className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
                      style={{ backgroundColor: item.color }}
                      transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                    />
                  )}
                </motion.div>
                <span
                  className={cn(
                    'text-xs mt-1 transition-all duration-200',
                    isActive ? 'font-semibold' : 'font-medium text-slate-400'
                  )}
                  style={{ color: isActive ? item.color : undefined }}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
